import { Box } from '@zillow/constellation-10';

import { useSelector } from '../../../../selectors/useSelector';
import { AppSelectors } from '../../../../selectors';

import MidwestStyleHouse1x from '../../../../images/MidwestStyleHouse@1x.svg';
import MidwestStyleHouse2x from '../../../../images/MidwestStyleHouse@2x.svg';
import { propertyPhotoStyles } from '../styles';

export const PropertyPhoto = () => {
  const photos = useSelector((state) => state.properties.currentProperty.photos);
  const primaryPhotoUrl = photos.length ? photos[0].url : null;

  const isScreenMobile = useSelector((state) => AppSelectors.makeIsScreenMobile(state));

  return (
    <Box
      css={{
        backgroundSize: primaryPhotoUrl
          ? 'cover'
          : {
              base: '70px',
              md: '105px',
            },
        ...propertyPhotoStyles,
      }}
      style={{
        backgroundImage: primaryPhotoUrl
          ? `url(${primaryPhotoUrl})`
          : isScreenMobile
            ? `url(${MidwestStyleHouse2x})`
            : `url(${MidwestStyleHouse1x})`,
      }}
    />
  );
};
